// extracted by mini-css-extract-plugin
export default {"productcard":"JA","productimage":"KA","username":"LA","multiBagName":"MA","productinfo":"NA","productinfoinner":"OA","productname":"PA","productsubheader":"QA","productdescription":"RA","productnumbers":"SA","productnumberstitle":"TA","productnumbersitem":"UA","number":"VA","numbertext":"WA","tabs":"XA","benefitsblock":"YA","benefit":"ZA","benefitname":"aB","benefitdescription":"bB","ingredientsblock":"cB","tipsblock":"eB","mobileonly":"fB"};
    if(module.hot) {
      // 1713809678203
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  